import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
  {/* Start Footer Area */}
  <footer className="footer1">
    <div className="footer-area footer-area-2 footer-area-3">
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="footer-content footer-center text-center">
              <div className="footer-head">
                <div className="footer-logo">
                <Link to={""}>
                    <img src="img/logo/logo4.png" alt="" />
                  </Link>
                </div>
                <p>
                  When replacing a selection. help agencies to define their new
                  business objectives and then create. maintains the amount of
                  lines. When replacing a selection.
                </p>
                <div className="footer-icons">
                  <ul>
                    <li>
                    <Link to={""}>
                        <i className="fa fa-facebook" />
                      </Link>
                    </li>
                    <li>
                    <Link to={""}>
                        <i className="fa fa-twitter" />
                      </Link>
                    </li>
                    <li>
                    <Link to={""}>
                        <i className="fa fa-google" />
                      </Link>
                    </li>
                    <li>
                    <Link to={""}>
                        <i className="fa fa-pinterest" />
                      </Link>
                    </li>
                    <li>
                    <Link to={""}>
                        <i className="fa fa-instagram" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* end single footer */}
        </div>
      </div>
    </div>
    {/* Start Footer Bottom Area */}
    <div className="footer-area-bottom footer-area-bottom-2">
      <div className="container">
        <div className="row">
          {/* <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="copyright">
              {/* <p>
                Copyright © 2023
              <Link to={""}>hnhtechsolutions</Link> All rights reserved
              </p> */}
            {/* </div>
          </div> */} 
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="footer-menu text-center">
              <ul>
                <li>
                  <Link to={"/"}>Home</Link>
                </li>
                <li>
                  <Link to={"/contact"}>Contact</Link>
                </li>
                <li>
                  <Link to={"/service"}>Services</Link>
                </li>
                {/* <li>
                  <Link to={""}>Chat box</Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* End Footer Bottom Area */}
  </footer>
  {/* End Footer Area */}
</>

  )
}

export default Footer